import "./Interests.css";
export default function Home() {
  return (
    <div>
      <section id="home" class="container py-5">
        <h2>Welcome to My Portfolio</h2>
        <p>
          <p class="text-center">
            Hi, I'm Whitney Mmaitsi , a Data Analyst, Web Developer, and
            Economist. I combine data-driven insights with web development and
            economic analysis to create impactful solutions. Currently, I'm
            expanding my skills in React, Python, and databases.
          </p>
        </p>
        <p>Explore my work, skills, and get to know more about me!</p>
      </section>
    </div>
  );
}
